import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import './Header.css';

export function Header() {
    const [menuOpen, setMenuOpen] = useState(false);
    const [scrolled, setScrolled] = useState(false);
    const location = useLocation();

    useEffect(() => {
        const handleScroll = () => setScrolled(window.scrollY > 10);
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    useEffect(() => {
        setMenuOpen(false);
    }, [location.pathname]);

    const isHome = location.pathname === '/';

    return (
        <header className={`sp-header ${scrolled ? 'sp-header--scrolled' : ''} ${isHome ? 'sp-header--transparent' : ''}`}>
            <div className="sp-header__inner">
                {/* Logo */}
                <Link className="sp-header__logo" to="/" aria-label="SmartPet - Inicio">
                    <span className="sp-header__brand">Smart<span>Pet</span></span>
                </Link>

                {/* Desktop Nav */}
                <nav className="sp-header__nav sp-header__nav--desktop">
                    <Link to="/about" className="sp-header__link">Nosotros</Link>
                    <Link to="/contacto" className="sp-header__link">Contacto</Link>
                    <Link to="/comprar" className="sp-header__link">Comprar</Link>
                </nav>

                {/* Right side */}
                <div className="sp-header__right">
                    <Link to="/login" className="sp-header__login">Iniciar sesión</Link>
                    <Link to="/register" className="sp-header__register">Registrarse</Link>

                    {/* Mobile hamburger */}
                    <button
                        className="sp-header__hamburger"
                        onClick={() => setMenuOpen(!menuOpen)}
                        aria-label={menuOpen ? 'Cerrar menú' : 'Abrir menú'}
                    >
                        {menuOpen ? <X size={24} /> : <Menu size={24} />}
                    </button>
                </div>
            </div>

            {/* Mobile Menu */}
            <div className={`sp-header__mobile ${menuOpen ? 'sp-header__mobile--open' : ''}`}>
                <Link to="/about" className="sp-header__mobile-link" onClick={() => setMenuOpen(false)}>Nosotros</Link>
                <Link to="/contacto" className="sp-header__mobile-link" onClick={() => setMenuOpen(false)}>Contacto</Link>
                <Link to="/comprar" className="sp-header__mobile-link" onClick={() => setMenuOpen(false)}>Comprar</Link>
                <div className="sp-header__mobile-divider" />
                <Link to="/login" className="sp-header__mobile-link sp-header__mobile-link--primary" onClick={() => setMenuOpen(false)}>Iniciar sesión</Link>
                <Link to="/register" className="sp-header__mobile-link sp-header__mobile-link--outline" onClick={() => setMenuOpen(false)}>Crear cuenta</Link>
            </div>
        </header>
    );
}